import * as types from '../mutation-types';

const state = {
  intended: null
};

const getters = {};

const actions = {
  setIntendedRoute({ commit }, route) {
    commit(types.SET_INTENDED_ROUTE, { route });
  },
  clearIntendedRoute({ commit }) {
    commit(types.CLEAR_INTENDED_ROUTE);
  }
};

const mutations = {
  [types.SET_INTENDED_ROUTE](state, { route }) {
    state.intended = route;
  },
  [types.CLEAR_INTENDED_ROUTE](state) {
    state.intended = null;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
